var a=a=>a?.size==0;export{a as default};